import Utils from "../utils.class";

const {jQuery: $} = window;

export default class TabsLayout {

    #theme;
    #$tabs;
    #updateInterval = 500;

    /**
     * @param {Theme} theme
     */
    constructor(theme) {
        this.#theme = theme;
        this.#$tabs = $('.static-tabs');
        Utils.log("Registered: Tabs Layout");
    }

    init() {
        Utils.equalHeight('.single_tab__content', '.verticalTabs__two');

        setInterval(() => this.timer(), this.#updateInterval);
    }

    events() {
        const me = this;

        this.#$tabs.each((i, el) => {
            const $el = $(el);
            const loadedTab = sessionStorage.getItem($el.attr("id"));

            if(loadedTab && loadedTab > 0) {
                setTimeout(() => {
                    this.activate($el.find('.verticalTabs .single_tab__tab[data-tab="'+loadedTab+'"]'));
                }, 1);
            }
        });

        this.#$tabs.find('.verticalTabs .single_tab__tab').on('click', function () {
            $(this).parents('.static-tabs').addClass("js--manual");
            me.activate($(this));
        });

        this.#$tabs.find('.verticalTabs__mobile').on('click', function () {
            const $parent = $('.verticalTabs');
            $parent.find('.verticalTabs__tabs').toggleClass("verticalTabs__tabs--open");
            $parent.find('.verticalTabs__mobile').toggleClass("verticalTabs__mobile--open");
        });

        this.#$tabs.find('.verticalTabs').each(function (i, el) {
            const $tab = $(el).find('.single_tab__overtab:first-child');
            $(el).find('.verticalTabs__mobile').html($tab.prop('outerHTML'));
            $(el).attr("data-height", $(el).find('.verticalTabs__two').css("max-height"));
        });
    }

    timer() {
        this.#$tabs.not(".js--manual").each((i, el) => {
            const $el = $(el);
            const timeout = $el.data("timeout");
            const $active = $el.find(".single_tab__overtab.active");
            const $timer = $active.find(".single_tab__timer");
            let progress = $el.data("progress") || 0;

            // Increment progress bar based on % of timeout so that the bar reaches 100% after the correct time has passed
            progress = progress + (timeout / (timeout / this.#updateInterval));

            $el.data("progress", progress);

            // Use CSS animation and move bar by whatever % is needed since last interval
            $timer.css("transition-duration", `${this.#updateInterval}ms`).width((100 * (progress / timeout)) + "%");

            if(progress >= timeout) {
                let num = Number($active.attr('data-tab')) + 1;
                const $next = $el.find(`.single_tab__tab[data-tab='${num}']`);

                if($next.length > 0) {
                    this.activate($next);
                } else {
                    this.activate($el.find(`.single_tab__tab[data-tab='1']`));
                }

                $el.data("progress", 0);
                $timer.css("transition-duration", `0ms`).width("0%");
            }
        });
    }

    activate($el) {
        const num = $el.attr('data-tab');
        const $parent = $el.parents('.static-tabs');
        const $tabs = $parent.find('.verticalTabs');
        const $content = $parent.find('.verticalTabs__two');
        const $tab = $el.parents('.single_tab__overtab');
        const $extras = $parent.find('.verticalTabs__extra');

        sessionStorage.setItem($parent.attr("id"), num);

        $content.find('.single_tab__content').removeClass('active').addClass('off');
        $content.find('[data-tab="' + num + '"]').addClass('active').removeClass('off');

        $tabs.find('.single_tab__overtab').removeClass('active').addClass('off');
        $tab.addClass('active').removeClass('off');

        $extras.find('.single_tab__extra').removeClass('active').addClass('off');
        $extras.find('[data-tab="' + num + '"]').addClass('active').removeClass('off');

        $parent.find('.verticalTabs__mobile').html($tab.prop('outerHTML'));
        $parent.find('.verticalTabs__tabs').removeClass('verticalTabs__tabs--open');
    }
}
